import { SVGProps } from 'react';

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Zm-5-8c0 2.25 1.842 4 5.088 4C15.333 18 17 16.417 17 14.417s-1.053-3-3.509-3.417l-1.93-.333c-1.14-.2-1.49-.5-1.49-1.084 0-.666.613-1.25 1.841-1.25 1.369 0 2.193.767 2.193 1.667h2.807c0-2.333-1.754-4-5-4C8.93 6 7.263 7.583 7.263 9.583c0 1.834 1.053 2.867 3.246 3.25l1.93.334c1.315.233 1.754.666 1.754 1.25 0 .666-.614 1.25-2.105 1.25S9.807 14.917 9.807 14H7Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgComponent;
